import { AppDefaultNavigationState } from '../../../initialStateRegistration';

export const getMenu = (state: AppDefaultNavigationState) => state.menu;
